import React from 'react';

import { Auth } from 'aws-amplify';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { onWelcomeMsg } from '../../actions/FlashMessage/FlashMessages';
import { setPageTitle } from '../../actions/Page/PageAction';
import { getReportMenu } from '../../actions/Page/PageAction';
import {
  getUserEmail,
  getUserToken,
  getUserDetailsFromSession,
  setLoggedUserDetailsSuccess,
} from '../../actions/Users/UserAction';
import { SUPER_USER } from '../../actionTypes/Users/UserActionType';
import { hasAnyError, validateAny, validatePhoneNumber } from '../Common/Errors/Errors';
import { Button } from '../Common/Button';
import Inputs from '../Common/Inputs/Inputs';
import MobileInput from '../Common/Inputs/MobileInput';
import FlashMessages from '../Common/Messages/FlashMessages';
import Footer from '../Footer/Footer';
import Header from '../Headers/Header';
import { Form } from 'reactstrap';
import { G_MSG_CHANNEL } from '../../routes/PRoute';
import Api from '../../Api';
import PasswordStrength from '../Password/PasswordStrength';
import withNavigate from '../HOC/navigate';
import withLocation from '../HOC/WithLocation';
class SignUp extends React.Component {
  state = {
    username: '',
    password: '',
    confPassword: '',
    given_name: '',
    family_name: '',
    phone_number: '',
    guid: '',
    formInputsValidation: {},
    msgType: '',
    message: '',
    isBusy: false,
    dirty: false,
    failedLabels: [],
  };

  constructor(props) {
    super(props);
  }

  handleInputChange = (inputFields, value) => {
    this.setState({
      dirty: true,
      [inputFields.name]: value,
    });
  };

  componentDidMount() {
    this.props.setPageTitle('Account Activation');

    Auth.signOut();

    const value = queryString.parse(this.props.location.search);
    this.props.getUserEmail(value?.guid, (respCall) => {
      if (respCall.email !== null) {
        this.setState({
          username: respCall.email,
          showWelcomeBanner: respCall.showWelcomeBanner,
          guid: respCall.guid,
        });
      } else {
        this.setError('Invalid Link');
      }
    });
  }

  componentWillUnmount() {
    this.props.setPageTitle();
  }

  signUpFlow = () => {
    const { isBusy, password, confPassword, given_name, family_name, phone_number, failedLabels } = this.state;

    const formInputsValidation = {
      family_name: validateAny(family_name),
      given_name: validateAny(given_name),
      phone_number: validatePhoneNumber(phone_number),
      password: validateAny(password),
      confPassword: validateAny(confPassword),
      matchPasswords: validateAny(password && password === confPassword),
      passwordStrength: validateAny(failedLabels.length === 0),
    };

    this.setState({ formInputsValidation });
    const hasErrors = hasAnyError(formInputsValidation);

    !formInputsValidation.confPassword && !formInputsValidation.password && formInputsValidation.matchPasswords
      ? this.setErrUnmatchedPasswords(this.arePasswordsEquals())
      : void 0;

    !hasErrors && !isBusy ? this.doSignup() : void 0;
  };

  arePasswordsEquals = () => {
    const { password, confPassword } = this.state;
    return password && password === confPassword;
  };

  doSignup = async () => {
    const { navigate } = this.props;
    const { password, given_name, family_name, phone_number, guid } = this.state;
    const username = this.state.username.toLowerCase().trim();
    G_MSG_CHANNEL.postMessage({ action: 'logout', userEmail: username });
    try {
      Api.instance.reset();
      this.setState({ isBusy: true });

      const payload = {
        username,
        password,
        attributes: {
          phone_number: `+${phone_number}`,
          given_name,
          family_name,
        },
        validationData: {
          guid,
        },
      };

      await Auth.signUp(payload);
      await Auth.signIn(username, password);

      const userDetails = await getUserDetailsFromSession();
      this.props.getUserToken();
      this.props.setLoggedUserDetailsSuccess(userDetails);
      const isSuperUser = userDetails?.userRoleConstant === SUPER_USER;

      navigate(isSuperUser ? '/users' : '/');

      // TODO: temporary solution to show message on the Layout after we move to the users list
      setTimeout(() => {
        this.state.showWelcomeBanner
          ? this.props.onWelcomeMsg(
              'Welcome to Analytics by Liaison!',
              'Your account setup is being finalized, and you’ll be able to view dashboards within one day.',
              '/',
            )
          : void 0;
      }, 0);
    } catch (err) {
      this.setError(err ? err.message : err);
      this.setState({ isBusy: false });
    }
  };

  setError = (message) => {
    this.setState({ message });
  };

  setErrUnmatchedPasswords = (areEqual) => {
    this.setError(areEqual ? void 0 : 'Password is not matching with confirm password');
  };

  hideFlashMessage = () => {
    this.setError();
  };

  render() {
    const { isDisabled } = this.props;
    return (
      <React.Fragment>
        <Header plainLogo />
        <main className="main-page" aria-describedby="app_page_title">
          <FlashMessages
            scope="SignUp"
            classNames={'fl-sing-up'}
            close={this.hideFlashMessage}
            type="error"
            msg={this.state.message}
            open={!!this.state.message}
          />
          <div tabIndex={0} className="mobile_margin signUp fontSm-15 no-focus">
            <h1 className="heading-h1-50" id="app_page_title">
              Account Activation
            </h1>
            <Form className="signUp-form margin-center">
              <h2 className="heading-h6-20">Account Information</h2>
              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.username}
                required="required"
                title="Email"
                autoComplete="email"
                name="username"
                id="username"
                placeholder="username"
                disabled={isDisabled !== undefined ? isDisabled : true}
                value={this.state.username}
              />

              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.password}
                required="required"
                title="Password"
                autoComplete="new-password"
                name="password"
                id="password"
                type="password"
                placeholder="Password"
                value={this.state.password}
              />

              <PasswordStrength
                newPassword={this.state.password}
                dirty={this.state.dirty}
                onState={(state) => {
                  this.setState({
                    failedLabels: state.failedLabels,
                  });
                }}
                showErrorMessage={this.state.formInputsValidation.passwordStrength}
                errorMessage="Check your password! It must meet minimal requirements."
              />

              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.confPassword}
                required="required"
                title="Confirm Password"
                autoComplete="new-password"
                name="confPassword"
                id="confPassword"
                type="password"
                placeholder="Confirm Password"
                value={this.state.confPassword}
              />

              <h2 className="heading-h6-20 pTop-15">User Information</h2>

              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.given_name}
                required="required"
                title="First Name"
                name="given_name"
                autoComplete="given-name"
                id="firstName"
                placeholder="First Name"
                value={this.state.given_name}
              />

              <Inputs
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.family_name}
                required="required"
                autoComplete="family-name"
                title="Last Name"
                name="family_name"
                id="lastName"
                placeholder="Last Name"
                value={this.state.family_name}
              />

              <MobileInput
                onInputChange={this.handleInputChange}
                errorMessages={this.state.formInputsValidation.phone_number}
                required="required"
                name="phone_number"
                id="phoneNumber"
                title="Mobile Number"
                value={this.state.phone_number}
              />

              <div className="text-center mTop-30">
                <Button
                  isNew
                  size="large"
                  busy={this.state.isBusy}
                  text="Activate Account"
                  onClick={this.signUpFlow}
                  id="button-signup"
                />
                <div className="anchorParent mTop-10">
                  <a
                    className="text-right inline-block anchor widthCust-30"
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://help.liaisonedu.com/Analytics">
                    Need Help?
                  </a>
                </div>
              </div>
            </Form>
          </div>
        </main>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps() {
  return {};
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUserEmail,
      onWelcomeMsg,
      getReportMenu,
      getUserToken,
      setPageTitle,
      setLoggedUserDetailsSuccess,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(withLocation(withNavigate(SignUp)));
